<template>
    <div class="activity-content">
        <div class="activity-banner">
            <img src="../../assets/images/tjyl-banner@2x.png" alt />
            <a href="javascript:;" class="go-back activity-back" @click="e=>this.$router.back()"></a>
        </div>
        <div class="activity-list">
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年4月1日至5月31日</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-2@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item">上海农商银行个人信用卡主卡持卡客户(仅持公益护照、分期类等专用信用卡的客户除外)</div>
                         <div class="apply-button-wrapper">
                             <a href="javascript:;" @click="e=>{this.$test('recommend a-register-2') ;this.$listeners.routePusht('https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX02&validate=20991231')}"  class="apply-activity-btn" ></a>
                        </div> 
                    </div>
                </div>
            </div>
            <div class="a-list-item-wrap">
                <div class="a-list-block">
                    <div class="left-item">
                        <img src="../../assets/images/tjyl-icon-1@2x.png" class="a-item-icon" alt />
                    </div>
                    <div class="right-item">
                        <h5>活动内容</h5>
                        <div class="text-item-warp">
                            <p>推荐有礼</p>
                            <div
                                class="text-item tyjl-text"
                            >活动期间,在每一轮活动周期内,“推荐人”通过活动页面生成专属推广链接或二维码,成功邀请“被推荐人”申办并核发本行个人信用卡,且“被推荐人”在每一轮活动周期的指定时间段内激活卡片,“推荐人”可按照成功推荐客户的人数获得以下奖励,奖励名额有限,先到先得！</div>
                            <a
                                @click="e=>{this.$test('recommend a-register-1-2')}"   
                                href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6195472c073b880c&redirect_uri=https://onlinepay.cupdata.com/nweixin/ssoLogin.do?action=loginAndSign&response_type=code&scope=snsapi_base&state=6501!Coas!M15#wechat_redirect"
                                class="more-rule tjyl-button"
                            ></a>
                        </div>
                    </div>
                </div>
                <div class="a-block">
                      
                       <div class="block-text">
                           <h5>第一轮活动周期：</h5>
                           <p>被推荐人需在4月1日至4月30日间核卡,并在5月31日前激活卡片；</p>
                       </div>
                       <div class="block-text" >
                           <h5>第二轮活动周期：</h5>
                           <p>被推荐人需在5月1日至5月31日间核卡,并在6月30日前激活卡片。</p>
                       </div>
                       <span class="line"></span>

                       <div class="block-table">
                           <h5>每一轮活动周期内成功推荐客户数及推荐人可获奖励：</h5>
                           <img src="../../assets/images/tjyl-table@2x.png" alt="">
                      
                       </div>
                       <div class="tjyl-tip">
                            <h5>注意事项</h5>
                            <p>1. “推荐人”是指本行个人信用卡主卡持卡客户(仅持公益护照、分期类等专用信用卡的客户除外)。</p>
                            <p>2.“被推荐人”是指通过“推荐人”邀请链接,进入网申渠道首次成功申办并核发本行个人信用卡的新客户。</p>
                            <p>3. 每一轮活动周期内的推荐客户数将独立计算。</p>
                       </div>
                </div>
             
            </div>

            <div class="a-list-item a-footer-item">
                <div class="rule-details">
                    <h5>活动细则</h5>
                    <div class="rule-text">
                        <p>1.活动内容及细则所述的“本行个人信用卡”是指除公益护照、鑫智白金卡、白金商务卡、商务卡、鑫成卡、鑫福农卡、鑫风卡、优享白金鑫卡随鑫专用卡、优享白金鑫卡分期专用卡、鑫驰白金卡车牌分期专用卡、优享白金鑫卡(车牌分期)、增值服务通个人卡、鑫合农卡、乡村振兴卡,之外的,本行发行的个人账户信用卡。</p>
                        <div class="more-text" v-show="isShow">
                            <p>2.“被推荐人”可申办的本行个人信用卡具体包括：鑫驰白金卡、工会会员服务卡(IC贷记卡)、上海海昌海洋公园联名卡、哈炫亲子联名卡、百动联名白金卡/金卡、淘宝鑫卡(金卡及普卡)、上海购物IC卡、优享白金鑫卡。新客户是此前从未在上海农商银行申办过信用卡业务的客户。</p>
                            <p>3.本次活动中,“推荐人”信用卡账户状态需正常,参与资格以活动页面显示为准。“被推荐人”需为通过“推荐人”专属推广链接或二维码首次申办本行个人信用卡的新客户,且需在每轮活动周期的指定时间段内核卡及激活。</p>
                            <p>4.每轮活动周期内的被推荐客户数独立计算,不予累加。每轮活动周期内每位“推荐人”仅可获得一档奖励,将按最高档位达标礼品认定获得相应奖励。</p>
                            <p>5.活动期间,如“被推荐人”受到同一或不同“推荐人”邀请,核发并激活了两张及以上信用卡的,活动奖励记录以“被推荐人”核发的第一张信用卡所属的“推荐人”为准。</p>
                            <p>6.如“被推荐人”于活动所赠奖励发放前注销符合活动条件的卡片,则“推荐人”在每一轮活动周期内成功推荐的客户数将相应减少,活动所赠奖励也将视减少后的成功推荐客户数进行奖励档位匹配。</p>
                            <p>7.活动奖励名额达标3人,共计500个名额赠送300元油卡；达标5人,共计200个名额赠送500元油卡；达标10人,共计100个名额赠送1200元油卡；达标20人,共计50个名额赠送2500元油卡；达标1人,共计1000个名额赠送10000积分,活动名额有限,先到先得。</p>
                            <p>8.活动所赠奖励中,中石化电子加油券将于每轮活动结束后(即每轮卡片激活截止日开始计算)的60个工作日内以电子兑换券形式短信发送至推荐人在本行信用卡系统中预留的手机号码。推荐人可以通过中国石化网上营业厅(www.sinopecsales.com)、中国石化加油卡掌上营业厅APP等渠道完成电子加油券的兑换和充值。具体操作方式可咨询中国石化客服热线95105888。</p>
                            <p>9.活动所赠奖励中,信用卡积分奖励将于每轮活动结束后(即每轮卡片激活截止日开始计算)的60个工作日内加入推荐人信用卡积分账户。</p>
                            <p>10.本次活动的活动时间为北京时间,活动页面中的“参与情况查询”仅供参考。活动中活动对象、核卡、激活、成功推荐客户数等参与情况以上海农商银行信用卡系统记录为准。</p>
                            <p>11.持卡人如有下述任何一种情况,其享受本活动的资格将被取消,包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡(个人卡)领用合约》或本活动细则及相关规定的。</p>
                            <p>12.如发现持卡人有利用活动规则或系统漏洞、作弊、冒用他人信息参与活动、进行虚假交易或者违法交易等手段恶意套取优惠奖励的,上海农商银行保留取消该持卡人参加本活动的权利,并有权取消或收回其因参加本活动所获的回馈和奖励。</p>
                            <p>13.在法律许可范围内,上海农商银行有权修订本活动条款及细则(包括但不限于参加资格、消费时间及奖励方式等)、暂停或取消本活动、并经相关途径(如上海农商银行官方网站、对账单、短信、信用卡微信公众号或各分支网点等)公告后生效。</p>
                            <p>14.其他未尽事宜,仍受《上海农商银行信用卡章程》、《上海农商银行信用卡(个人卡)领用合约》及其他相关文件约束。</p>
                            <p>15.活动详情以上海农商银行最新公布内容为准,或咨询24小时客服热线021-962999或4006962999。在法律许可范围内,上海农商银行保留活动最终解释权。 </p>
                        </div>
                    </div>
                    <a
                        href="javascript:;"
                        class="more-rule"
                        @click="changeMoreRule"
                        v-show="!isShow"
                    >展开详情</a>
                    <div class="collect-wrap" v-show="isShow">
                        <div class="collect-btn" @click="changeMoreRule">
                            <i class="collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { isShow: false };
    },
    methods: {
        changeMoreRule() {
            this.isShow = !this.isShow;
            // this.$test("recommend a-detail-2");
        }
    }
};
</script>

<style lang="scss" scoped>
</style>